import React, {Component} from 'react';
import PageProperties from '../Properties/PageProperties'
import ElementProps from '../ElempentProps';
import objeler from '../objeler';
import ModalBase from './ModaBase';

class ModalDialogPage extends Component<props> {
    static defaultProps = {
        objects: {}
    };
    customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: '800px',
            height: '550px',
            transform: 'translate(-50%, -50%)'
        }
    };

    constructor(props) {
        super(props);
        this.state = {modalPageIsOpen: false, setPageIsOpen: false, ElementProps};
        this.FilePropRef = React.createRef();
    }

    afterOpenModal = () => {
    }
    closeModal = (b) => {
        if (b !== "Cancel") {
            objeler.ModalPageParameters = {...objeler.ModalPageValues};
            objeler.ModalPageValues = {};
            this.props.closeModal("dosya ismi", objeler.ModalPageParameters);
        } else {
            objeler.ModalPageValues = {};
            this.props.closeModal("Cancel");
        }
        return;
        objeler.closeModalFile(e);
        if (b === "OK")
            this.props.closeModalFile(objeler.tarik);
        else
            this.props.closeModalFile("Cancel");
    }

    render() {
        const {objects, DocProps} = this.props;
        const {classes} = this.props;
        let ModalPageParameters = {id: 0};
        if (objeler.ModalPageParameters != undefined)
            ModalPageParameters = objeler.ModalPageParameters;
        return (
            <div>
                <ModalBase
                    isOpen={this.props.isOpen}
                    closeModal={this.closeModal}
                    title={'Page Preferences (' + ModalPageParameters.id + ')'}
                >
                    <table className="ta ble" height="90%" style={{border: "2px"}}>
                        <tbody>
                        <tr>
                            <td scope="col" colSpan="3">
                                <PageProperties onDocChange={this.onDocChange}
                                                PageProps={objeler.ModalPageParameters}></PageProperties>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </ModalBase>
            </div>
        );
    }
}

export default ModalDialogPage;